// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__-suDK","badge":"tabs_badge__eaJzw","badge-yellow":"tabs_badge-yellow__kcpga","badge-green":"tabs_badge-green__cU-Y4","badge-red":"tabs_badge-red__H0AY8"};